import { siInstagram, siSpotify, siTiktok, siTwitch, siYoutube } from "simple-icons";

const ICONS = { spotify: siSpotify, youtube: siYoutube, instagram: siInstagram, tiktok: siTiktok, twitch: siTwitch };

export function SocialIcon({ id, size = 16, className = "" }) {
  const icon = ICONS[id];
  if (!icon) return null;
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true" focusable="false" className={`shrink-0 ${className}`} data-testid={`social-icon-${id}`}>
      <path d={icon.path} />
    </svg>
  );
}
